import { Pets } from '@mui/icons-material'
import { AppBar, Box, Menu, MenuItem, styled, Toolbar, Typography } from '@mui/material'
import React, { useState } from 'react'
import { Link } from "react-router-dom";

const StyledToolbar = styled(Toolbar)({
  display: "flex",
  justifyContent: "space-between"
})

const IconBox = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: "20px",
  // [theme.breakpoints.up("sm")]: {
  //   display: "flex",
  // }
}))

const Navbar = () => {
  const [open, setOpen] = useState(false);
  return (
    <AppBar position="sticky">
      <StyledToolbar>
        <Typography variant='h6' sx={{ display: { xs: "none", sm: "block" } }}>Telecom</Typography>
        <Pets sx={{ display: { xs: "block", sm: "none" } }} />
        <IconBox>
          <Link to="invoice" style={{ color: "#FFF" }}>
            PDF
          </Link>
          {/* <MoreVert
            sx={{ width: 30, height: 30 }}
            onClick={() => setOpen(true)}
          /> */}
        </IconBox>
      </StyledToolbar>
      <Menu
        id="demo-positioned-menu"
        open={open}
        onClose={(_) => setOpen(false)}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
      >
        <MenuItem >Profile</MenuItem>
        <MenuItem >My account</MenuItem>
        <MenuItem >Logout</MenuItem>
      </Menu>
    </AppBar>

  )
}

export default Navbar